// ProductDetails.jsx
import React from 'react';
import './product-details-page-v1.scss';
import { LoadingSpinner, SVGS } from '@zonofi/zono-money-design-system';
import {
  MoqErrorSnackBar,
  ProductDetailsContent,
  ProductDetailsGalleryView,
  ProductDetailsHeader,
  ProductDetailsImageGallery,
  ProductFooter,
} from '@zonofi/zono-money-whatsapp-stack';
import { useProductDetailsV1 } from './hooks/use-product-details-page-v1';

interface ProductDetailsPageV1Props {
  showOutOfStack: boolean;
}

export const ProductDetailsPageV1: React.FC<ProductDetailsPageV1Props> = ({
  showOutOfStack,
}) => {
  const {
    productDetails,
    onAddToCart,
    onIncrement,
    onDecrement,
    onChangeQuantity,
    isLoading,
    totalCartItems,
    hidePrice,
    addedToCart,
    isMoqError,
    onDelete,
    showImageGallery,
    setShowImageGallery,
    hideImages,
    getProductDetailsResponse,
    facets,
    onSelectFacet,
    outOfStockFacetValueMap,
  } = useProductDetailsV1();

  return (
    <>
      <div className="product-details">
        {getProductDetailsResponse?.isLoading ? (
          <div className="product-details-loading">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <ProductDetailsHeader
              productName={productDetails.title}
              totalCartItems={totalCartItems ?? 0}
            />
            <div className="product-details-body">
              {!hideImages && (
                <ProductDetailsImageGallery
                  images={productDetails.images}
                  setShowImageGallery={setShowImageGallery}
                />
              )}
              <ProductDetailsContent
                productDetails={productDetails}
                hidePrice={hidePrice}
                hideImages={hideImages}
                facets={facets}
                onSelectFacet={onSelectFacet}
                showOutOfStack={showOutOfStack}
                outOfStockFacetValueMap={outOfStockFacetValueMap}
              />
            </div>
            <ProductFooter
              productDetails={productDetails}
              onAddToCart={onAddToCart}
              onIncrement={onIncrement}
              onDecrement={onDecrement}
              isLoading={isLoading}
              onChangeQuantity={onChangeQuantity}
              isMoqError={isMoqError}
              onDelete={onDelete}
              addedToCart={addedToCart}
              showOutOfStack={showOutOfStack}
            />
            {isMoqError && (
              <div className="moq-error-snackbar-container">
                <MoqErrorSnackBar number={productDetails.details.moq} />
              </div>
            )}
          </>
        )}
      </div>
      {showImageGallery && (
        <ProductDetailsGalleryView
          open={showImageGallery}
          onClose={() => setShowImageGallery(false)}
          images={productDetails.images.map((image) => {
            let newImage = image;
            if (image && image.startsWith('http')) {
              const urlObj = new URL(image ?? '');
              if (urlObj) {
                urlObj.searchParams.set('width', '500');
                urlObj.searchParams.delete('height', '500');
                newImage = urlObj.toString();
              }
            }
            return { src: newImage, alt: productDetails.title, type: 'image' };
          })}
        />
      )}
    </>
  );
};
